import { render, staticRenderFns } from "./manifest.vue?vue&type=template&id=0f896451&scoped=true"
import script from "./manifest.vue?vue&type=script&lang=js"
export * from "./manifest.vue?vue&type=script&lang=js"
import style0 from "./manifest.vue?vue&type=style&index=0&id=0f896451&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f896451",
  null
  
)

export default component.exports